import { z } from 'my-zod'
import { vehiclesModel } from './vehicles-model'

export const vehicleInternalCheckoutView = vehiclesModel.omit({
  contractedPickupDate: true,
  contractedArrivalDate: true,
  expectedSaleDate: true,
  saleDate: true,
  netSaleRevenue: true,
  billingPlan: true,
  warehouseId: true,
  landingPageEnabled: true,
  listingNotes: true,
  listingPrice: true,
  corporateFleetResponsibleUser: true,
  corporateFleetProjectNumber: true,
  ibmiShippingDestination: true,
  ibmiOrderNumber: true,
  ibmiAssignedEmployeeEmail: true,
  ibmiAssignedEmployeeName: true,
  ibmiAssignedEmployeeNumber: true,
  ibmiEmployeeUnitStatus: true,
  ibmiIsShippable: true,
  ibmiYldHoldExists: true,
  ibmiHoldExists: true,
  ibmiSafetyBulletinExists: true,
  ibmiIsPrecertified: true,
  ibmiIsCompetitor: true,
  customAssetFamilyId: true
})

export type vehicleInternalCheckoutView = z.infer<typeof vehicleInternalCheckoutView>
